export default "__VITE_ASSET__C2jeOiRc__"